import { render, staticRenderFns } from "./addMatchTournament.vue?vue&type=template&id=57287da4&scoped=true&"
import script from "./addMatchTournament.vue?vue&type=script&lang=js&"
export * from "./addMatchTournament.vue?vue&type=script&lang=js&"
import style0 from "./addMatchTournament.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./addMatchTournament.vue?vue&type=style&index=1&id=57287da4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57287da4",
  null
  
)

export default component.exports